// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#myprofile .profile-container {
    max-width: 900px;
    margin: 0 auto;
  }
  
  #myprofile .profile-header {
    padding: var(--spacing-lg) 0;
    margin-bottom: var(--spacing-xl);
    border-bottom: 1px solid var(--border-color);
  }
  
  #myprofile .profile-avatar {
    display: flex;
    align-items: center;
    gap: var(--spacing-lg);
  }
  #myprofile .form-group {
    margin-bottom: var(--spacing-md);
}
#myprofile label {
  display: block;
  margin-bottom: var(--spacing-xs);
  font-weight: 500;
}
#myprofile input, #myprofile select, #myprofile textarea {
  width: 100%;
  padding: var(--spacing-sm);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  font-size: 1rem;
}
#myprofile input:focus, #myprofile select:focus, #myprofile textarea:focus {
  outline: none;
  border-color: var(--primary-yellow);
  box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2);
}
#myprofile .up_sub_btn {
    background-color: var(--primary-yellow) !important;
    color: var(--primary-grey) !important;
}
#myprofile .password-input {
  position: relative;
}
#myprofile .password-input i {
  position: absolute;
  right: var(--spacing-md);
  top: 50%;
  left: unset;
  transform: translateY(-50%);
  color: var(--secondary-grey);
  cursor: pointer;
}
#myprofile .avatar-circle {
    width: 80px;
    height: 80px;
    background-color: #d7d4d4;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
#myprofile .avatar-circle span {
    font-size: 2rem;
    font-weight: 600;
    color: var(--primary-grey);
  }
  
#myprofile .profile-info h2 {
    margin: 0;
    color: var(--primary-grey);
  }
  
#myprofile .profile-info p {
    margin: var(--spacing-xs) 0 0;
    color: var(--secondary-grey);
  }
  
#myprofile .profile-tabs {
    display: flex;
    gap: var(--spacing-md);
    margin-bottom: var(--spacing-xl);
    border-bottom: 1px solid var(--border-color);
  }
  
#myprofile .tab-button {
    background: none;
    border: none;
    padding: var(--spacing-md) var(--spacing-lg);
    font-size: 1rem;
    border-radius: 4px;
    border: 1px solid var(--secondary-grey);
    /* border-bottom: none; */
    color: var(--secondary-grey);
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
    transition: all 0.3s ease;
  }
  
#myprofile .tab-button:hover {
    color: var(--primary-grey);
  }
  
#myprofile .tab-button.active {
    color: var(--primary-grey);
    font-weight: 500;
    background-color: var(--primary-yellow);
    border: 1px solid var(--primary-yellow);
    border-radius: 4px;
    /* border-bottom: none; */
  }
  
#myprofile .tab-button.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: var(--primary-yellow);
  }
  
#myprofile .profile-form {
    max-width: 800px;
    margin: 0 auto;
  }
  
#myprofile .form-row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: var(--spacing-lg);
    margin-bottom: var(--spacing-lg);
  }
  
#myprofile .password-input {
    position: relative;
  }
  
#myprofile .password-input input {
    padding-right: 40px;
  }
  
#myprofile .password-input i {
    position: absolute;
    right: var(--spacing-md);
    top: 50%;
    transform: translateY(-50%);
    color: var(--secondary-grey);
    cursor: pointer;
  }
  
#myprofile .form-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: var(--spacing-xl);
    padding-top: var(--spacing-lg);
    border-top: 1px solid var(--border-color);
  }
  
#myprofile .form-actions .btn {
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
  }
  
  @media (max-width: 768px) {
    #myprofile .form-row {
      grid-template-columns: 1fr;
    }
  
    #myprofile .profile-avatar {
      flex-direction: column;
      text-align: center;
    }
  
    #myprofile .profile-info {
      text-align: center;
    }
  
    #myprofile .profile-tabs {
      flex-direction: column;
    }
  
    #myprofile .tab-button {
      width: 100%;
      justify-content: center;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/MyProfile/MyProfile.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,gCAAgC;IAChC,4CAA4C;EAC9C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,gCAAgC;AACpC;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mCAAmC;EACnC,4CAA4C;AAC9C;AACA;IACI,kDAAkD;IAClD,qCAAqC;AACzC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,4BAA4B;EAC5B,eAAe;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;AAEF;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;EAC5B;;AAEF;IACI,SAAS;IACT,0BAA0B;EAC5B;;AAEF;IACI,6BAA6B;IAC7B,4BAA4B;EAC9B;;AAEF;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,4CAA4C;EAC9C;;AAEF;IACI,gBAAgB;IAChB,YAAY;IACZ,4CAA4C;IAC5C,eAAe;IACf,kBAAkB;IAClB,uCAAuC;IACvC,yBAAyB;IACzB,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;EAC3B;;AAEF;IACI,0BAA0B;EAC5B;;AAEF;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,uCAAuC;IACvC,uCAAuC;IACvC,kBAAkB;IAClB,yBAAyB;EAC3B;;AAEF;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,WAAW;IACX,uCAAuC;EACzC;;AAEF;IACI,gBAAgB;IAChB,cAAc;EAChB;;AAEF;IACI,aAAa;IACb,qCAAqC;IACrC,sBAAsB;IACtB,gCAAgC;EAClC;;AAEF;IACI,kBAAkB;EACpB;;AAEF;IACI,mBAAmB;EACrB;;AAEF;IACI,kBAAkB;IAClB,wBAAwB;IACxB,QAAQ;IACR,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;EACjB;;AAEF;IACI,aAAa;IACb,yBAAyB;IACzB,6BAA6B;IAC7B,8BAA8B;IAC9B,yCAAyC;EAC3C;;AAEF;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE;MACE,0BAA0B;IAC5B;;IAEA;MACE,sBAAsB;MACtB,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,WAAW;MACX,uBAAuB;IACzB;EACF","sourcesContent":["#myprofile .profile-container {\r\n    max-width: 900px;\r\n    margin: 0 auto;\r\n  }\r\n  \r\n  #myprofile .profile-header {\r\n    padding: var(--spacing-lg) 0;\r\n    margin-bottom: var(--spacing-xl);\r\n    border-bottom: 1px solid var(--border-color);\r\n  }\r\n  \r\n  #myprofile .profile-avatar {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: var(--spacing-lg);\r\n  }\r\n  #myprofile .form-group {\r\n    margin-bottom: var(--spacing-md);\r\n}\r\n#myprofile label {\r\n  display: block;\r\n  margin-bottom: var(--spacing-xs);\r\n  font-weight: 500;\r\n}\r\n#myprofile input, #myprofile select, #myprofile textarea {\r\n  width: 100%;\r\n  padding: var(--spacing-sm);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n}\r\n#myprofile input:focus, #myprofile select:focus, #myprofile textarea:focus {\r\n  outline: none;\r\n  border-color: var(--primary-yellow);\r\n  box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2);\r\n}\r\n#myprofile .up_sub_btn {\r\n    background-color: var(--primary-yellow) !important;\r\n    color: var(--primary-grey) !important;\r\n}\r\n#myprofile .password-input {\r\n  position: relative;\r\n}\r\n#myprofile .password-input i {\r\n  position: absolute;\r\n  right: var(--spacing-md);\r\n  top: 50%;\r\n  left: unset;\r\n  transform: translateY(-50%);\r\n  color: var(--secondary-grey);\r\n  cursor: pointer;\r\n}\r\n#myprofile .avatar-circle {\r\n    width: 80px;\r\n    height: 80px;\r\n    background-color: #d7d4d4;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n#myprofile .avatar-circle span {\r\n    font-size: 2rem;\r\n    font-weight: 600;\r\n    color: var(--primary-grey);\r\n  }\r\n  \r\n#myprofile .profile-info h2 {\r\n    margin: 0;\r\n    color: var(--primary-grey);\r\n  }\r\n  \r\n#myprofile .profile-info p {\r\n    margin: var(--spacing-xs) 0 0;\r\n    color: var(--secondary-grey);\r\n  }\r\n  \r\n#myprofile .profile-tabs {\r\n    display: flex;\r\n    gap: var(--spacing-md);\r\n    margin-bottom: var(--spacing-xl);\r\n    border-bottom: 1px solid var(--border-color);\r\n  }\r\n  \r\n#myprofile .tab-button {\r\n    background: none;\r\n    border: none;\r\n    padding: var(--spacing-md) var(--spacing-lg);\r\n    font-size: 1rem;\r\n    border-radius: 4px;\r\n    border: 1px solid var(--secondary-grey);\r\n    /* border-bottom: none; */\r\n    color: var(--secondary-grey);\r\n    cursor: pointer;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: var(--spacing-sm);\r\n    transition: all 0.3s ease;\r\n  }\r\n  \r\n#myprofile .tab-button:hover {\r\n    color: var(--primary-grey);\r\n  }\r\n  \r\n#myprofile .tab-button.active {\r\n    color: var(--primary-grey);\r\n    font-weight: 500;\r\n    background-color: var(--primary-yellow);\r\n    border: 1px solid var(--primary-yellow);\r\n    border-radius: 4px;\r\n    /* border-bottom: none; */\r\n  }\r\n  \r\n#myprofile .tab-button.active::after {\r\n    content: '';\r\n    position: absolute;\r\n    bottom: -1px;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 2px;\r\n    background-color: var(--primary-yellow);\r\n  }\r\n  \r\n#myprofile .profile-form {\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n  }\r\n  \r\n#myprofile .form-row {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    gap: var(--spacing-lg);\r\n    margin-bottom: var(--spacing-lg);\r\n  }\r\n  \r\n#myprofile .password-input {\r\n    position: relative;\r\n  }\r\n  \r\n#myprofile .password-input input {\r\n    padding-right: 40px;\r\n  }\r\n  \r\n#myprofile .password-input i {\r\n    position: absolute;\r\n    right: var(--spacing-md);\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    color: var(--secondary-grey);\r\n    cursor: pointer;\r\n  }\r\n  \r\n#myprofile .form-actions {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    margin-top: var(--spacing-xl);\r\n    padding-top: var(--spacing-lg);\r\n    border-top: 1px solid var(--border-color);\r\n  }\r\n  \r\n#myprofile .form-actions .btn {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: var(--spacing-sm);\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    #myprofile .form-row {\r\n      grid-template-columns: 1fr;\r\n    }\r\n  \r\n    #myprofile .profile-avatar {\r\n      flex-direction: column;\r\n      text-align: center;\r\n    }\r\n  \r\n    #myprofile .profile-info {\r\n      text-align: center;\r\n    }\r\n  \r\n    #myprofile .profile-tabs {\r\n      flex-direction: column;\r\n    }\r\n  \r\n    #myprofile .tab-button {\r\n      width: 100%;\r\n      justify-content: center;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
